import { ReactComponent as SvgAddCard } from './AddCard.svg.es.js';
import { ReactComponent as SvgApplePay } from './ApplePay.svg.es.js';
import { ReactComponent as SvgBankOfAmerica } from './BankOfAmerica.svg.es.js';
import { ReactComponent as SvgGooglePay } from './GooglePay.svg.es.js';
import { ReactComponent as SvgMastercard } from './Mastercard.svg.es.js';
import { ReactComponent as SvgVisa } from './Visa.svg.es.js';

const SvgPaymentIcons = {
    'Payment/AddCard': SvgAddCard,
    'Payment/ApplePay': SvgApplePay,
    'Payment/BankOfAmerica': SvgBankOfAmerica,
    'Payment/GooglePay': SvgGooglePay,
    'Payment/Mastercard': SvgMastercard,
    'Payment/Visa': SvgVisa
};

export { SvgPaymentIcons };
//# sourceMappingURL=index.es.js.map
